import {
  GET_SUPPLIERS,
  CREATE_SUPPLIER,
  REMOVE_SUPPLIER,
  UPDATE_SUPPLIER,
} from './types';

export const getSuppliers = (companyId) => ({
  type: GET_SUPPLIERS,
  request: {
    method: 'GET',
    url: `/company/${companyId}/suppliers`,
  },
  meta: {
    thunk: true,
  },
});

export const createSupplier = (companyId, payload) => ({
  type: CREATE_SUPPLIER,
  request: {
    method: 'POST',
    url: `/company/${companyId}/suppliers`,
    data: payload,
  },
  meta: {
    thunk: true,
  },
});

export const removeSupplier = (companyId, supplierId) => ({
  type: REMOVE_SUPPLIER,
  supplierId,
  request: {
    method: 'DELETE',
    url: `/company/${companyId}/suppliers/${supplierId}`,
  },
  meta: {
    thunk: true,
  },
});

export const updateSupplier = (companyId, supplierId, payload) => ({
  type: UPDATE_SUPPLIER,
  supplierId,
  request: {
    method: 'PATCH',
    url: `/company/${companyId}/suppliers/${supplierId}`,
    data: payload,
  },
  meta: {
    thunk: true,
  },
});
